module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-red-on-white-978daa23db9b73192112d1027a600deb.png";